import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { UserService } from 'src/app/core/user.service';

@Injectable({
  providedIn: 'root',
})
export class BaseGuard {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {}

  public canActivate(): UrlTree {
    const dashboard = this.userService.get('dashboard') || 'files';
    return this.router.createUrlTree([`/${dashboard}`]);
  }
}
